<div class="m-events">
    <div class="m-events__wrapper">
        <div class="m-events__header">
            <div class="m-events__filter-icon" (click)="isShowFilter = true">
                <svg-icon [src]="FILTER_ICON_PATH"></svg-icon>
            </div>
        </div>
        @if ((eventCards$ | async) && (eventCards$ | async).length) {
        <div class="m-events__cards">
            @for (card of eventCards$ | async; track $index) {
            <app-mobile-card [card]="card" [configPagination]="(params$ | async).pagination"></app-mobile-card>
            }
        </div>
        } @else {

        <div class="m-events__empty">
            <span [translate]="'table.noData'"></span>
        </div>

        }

        @if ((eventCards$ | async) && (eventCards$ | async).length) {
        <div class="m-events__paginate">

            <app-pagination [configPagination]="(params$ | async).pagination" [isMobile]="true"
                [customCountOption]="customCountOption" (paginationOutput)="changePage($event)"></app-pagination>
        </div>
        }
    </div>

    @if (isShowFilter) {
    <div class="m-events__filters">
        <app-mobile-filter [filters]="(params$ | async).filter"
            (changeFilterEvent)="isShowFilter = !isShowFilter; changeFilter($event)"></app-mobile-filter>
    </div>
    }
</div>